<template>
  <div>
    <v-dialog v-model="dialog" max-width="1200px" persistent scrollable>
      <v-card>
        <v-card-title class="primary white--text text-uppercase dialog-title">
          Xác nhận chấm thi
          <v-spacer></v-spacer>
          <v-btn dark icon>
            <v-icon @click="cancel" class="mr-n1" :disabled="loading">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="py-0">
          <AssignConfTable :documents="importedDocuments" :isImportPreview="true" />
        </v-card-text>
        <v-card-actions class="pa-6">
          <v-btn color="primary" @click="cancel" width="118" :loading="loading" large outlined>Hủy</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="confirm" :loading="loading" width="118" class="white--text elevation-0" large
            >Xác nhận</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { RoomSubject } from '../../plugins/api'
import AssignConfTable from './AssignConfTable.vue'
export default {
  props: {
    importedDocuments: Array,
    state: Boolean,
    all: Boolean,
    examId: String
  },
  components: {
    AssignConfTable
  },

  watch: {
    state(state) {
      this.dialog = state
      if (!state) {
        this.loading = false
      }
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      progressDialog: false,
      alertShown: false,
      progress: 0,
      formattedProgress: ''
    }
  },
  methods: {
    cancel() {
      this.$emit('closeDialog')
    },
    stopLoading() {
      this.loading = false
    },
    async confirm() {
      this.$loading.active = true
      const indexing = await RoomSubject.excelAssignExam({ exam: this.examId, roomDatas: this.importedDocuments })
      if (indexing) {
        this.$alert.success('Phân công thành công')
        this.cancel()
        this.$emit('refresh')
      } else {
        this.$alert.error('Lỗi phân công')
      }
      this.$loading.active = false
    }
  }
}
</script>
